import * as Sentry from '@sentry/react';
import { routes } from './js/shared/common/routes';
import { matchPath } from 'react-router';
import { createBrowserHistory } from 'history';

const __COMMIT_HASH__ = process.env.REACT_APP_COMMIT_HASH;

export const sentry = initSentry();

function initSentry() {
    const history = createBrowserHistory();

    const client = new Sentry.BrowserClient({
        dsn: process.env.REACT_APP_SENTRY_DSN,
        environment: getEnvironment(),
        release: __COMMIT_HASH__,
        transport: Sentry.makeFetchTransport,
        stackParser: Sentry.defaultStackParser,
        integrations: [
            ...Sentry.defaultIntegrations,
            new Sentry.BrowserTracing({
                routingInstrumentation: Sentry.reactRouterV5Instrumentation(history, routes, matchPath)
            })
        ]
    });

    return new Sentry.Hub(client);
}

function getEnvironment() {
    switch (window.location.hostname) {
        case 'connect.borrowbox.com':
            return 'production';
        case 'connect-stage.borrowbox.io':
            return 'stage';
        case 'connect-demo.borrowbox.com':
            return 'demo';
        default:
            return 'development';
    }
}
